<template>
	<page>
		<module height="auto">
			<div class="order-state flex-between-center">
				<h1>状态{{checkState}}：{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>
			
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>订单编号：</label>
							<p>{{orderDetail.sub_order_number}} <a @click="clipboard(orderDetail.sub_order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_classify == 1 && orderDetail.gh_order_number != orderDetail.order_number">
							<label>提货单号：</label>
							<p>{{orderDetail.gh_order_number}} <a @click="clipboard(orderDetail.gh_order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex" >
                            <label>销售方式：</label>
							<p v-if="orderDetail.order_classify ==1 && (orderDetail.agency_user_id == -2 || is_df == 1)" style="color: #FF0000">提货</p>
							<p v-if="orderDetail.order_classify ==1 && orderDetail.agency_user_id != -2 && is_df !=1" style="color: #B232FE">供货</p>
							<p v-if="orderDetail.order_classify ==2" style="color: blue">直销</p>
							<p v-if="orderDetail.order_classify ==3" style="color: green">囤货</p>
							<p v-if="orderDetail.order_classify ==4" style="color: red">云仓提货</p>
                            <div v-if="orderDetail.order_source == 'OMS'" class="tag" style="background:sandybrown">代下单</div>
                        </div>
						<!-- <div class="order-info-item flex" v-if="orderDetail.order_classify==1 && orderDetail.sub_order_numbers">
							<label>供货订单号集合：{{orderDetail.sub_order_numbers}}</label>
						</div> -->
						<div class="order-info-item flex" v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" >
							<label>运营模式：</label>
							<p>{{orderDetail.operation_mode==1?'平台自营':'商家自营'}}</p>
						</div>
						<div class="order-info-item flex" v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'"  >
							<label>商家角色：</label>
							<p>{{orderDetail.stationed_auth_name}}</p>
						</div>
						<div class="order-info-item flex" v-if="systemConfig.pt_mode == 2" >
							<label>所属商家：</label>
							<p>{{orderDetail.stationed_name}}</p>
						</div>
						<div class="order-info-item flex">
							<label>下单时间：</label>
							<p>{{orderDetail.create_date}} <!-- <a>更多</a> --></p>
						</div>
						<div class="order-info-item flex">
							<label>付款状态：</label>
							<p>{{paymentState}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.present_level_id!=0 && orderDetail.order_number == orderDetail.sub_order_number">
							<label>赠送会员：</label>
							<p>{{orderDetail.present_level_name}}</p>
						</div>
						<div class="order-info-item flex">
							<label>付款方式：</label>
							<p>{{orderDetail.payment_type?orderDetail.payment_type:'--'}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.payment_type=='银行转账'">
							<label>付款凭证：</label>
							<p><c-image :src="orderDetail.pay_voucher_url" size="20" preview></c-image></p>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info">
					<dt>买家/卖家信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>经销商昵称：</label>
							<p>{{orderDetail.nick_name3?orderDetail.nick_name3:'--'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>经销商手机号码：</label>
							<p>{{orderDetail.user_manage_mobilephone3?orderDetail.user_manage_mobilephone3:'-'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>采购人昵称：</label>
							<p>{{orderDetail.nick_name2?orderDetail.nick_name2:'-'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>采购人手机号码：</label>
							<p>{{orderDetail.user_manage_mobilephone2}}</p>
						</div>
						<div class="order-info-item flex">
							<label>采购人代码：</label>
							<p>{{orderDetail.user_login_name2}}</p>
						</div>
						<div class="order-info-item flex">
							<label>买家留言：</label>
							<p>{{orderDetail.order_remark?orderDetail.order_remark:'-'}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
							<label>定制附件：</label>
							<p class="flex">
								<template v-if="cusTomInfo.custom_attach_url">
									<c-image v-for="(item, i) in cusTomInfo.custom_attach_url.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;"></c-image>
								</template>
							</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
							<label>定制备注：</label>
							<p>{{cusTomInfo.custom_remark?cusTomInfo.custom_remark:'--'}}</p>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info" >
					<dt>物流信息</dt>
					<dd v-if="orderDetail.order_classify !=3">
						<div class="order-info-item flex">
							<label>收货人：</label>
							<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
						</div>
						<div class="order-info-item flex">
							<label>收货地址：</label>
							<p>{{orderDetail.receiving_address}}</p>
						</div>
						<div class="order-info-item flex">
							<label>配送方式：</label>
							<p>{{orderDetail.logistics_company_name}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货时间：</label>
							<p>{{orderDetail.send_dates}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货物流：</label>
							<p>{{orderDetail.send_logistics_numbers}}</p>
						</div>
					</dd>
                    <dd v-else>
                        <div class="order-info-item flex">
                            <label style="color: green">【云仓囤货】</label>
                            <p>无需物流发货</p>
                        </div>
                    </dd>
				</dl>
			</div>
		</module>
		
		<module>
			<div class="order-detail">
				<c-table v-model="productList" height="auto" :paging="false" border v-if="orderDetail">
					<c-table-column
						label="商品信息"
						width="300"
					>
						<template v-slot="{data}">
							<product-info :image="data.product_img_url" image-size="60" :name="data.product_name"></product-info>
						</template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="成交单价"
					>
						<template v-slot="{data}">
							<span>
								{{orderDetail.order_type==2?"":"￥"}}
								{{orderDetail.order_type==2?data.product_unit_price:parseFloat(data.sub_product_unit_price).toFixed(2)}}
								{{orderDetail.order_type==2?"积分":""}}
								
								<font style="text-decoration: line-through;color:#999999;" v-if="data.sub_product_unit_price!=data.original_product_price">
									<br/>
									<!--{{orderDetail.order_type==2?"":"￥"}}-->
									￥
									{{orderDetail.order_type==2?data.original_product_price:parseFloat(data.original_product_price).toFixed(2)}}
									<!--{{orderDetail.order_type==2?"积分":""}}-->
								</font>
							</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="折扣率"
						width="70"
						v-if="orderDetail.order_type != 2"
					>
						<template v-slot="{data}">
							<span v-if="orderDetail.order_classify != 1">
								{{parseFloat(data.sub_product_unit_price*data.product_count*100/data.original_quoted_money).toFixed(2)}}%
							</span>
							<span v-else>-</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品总额"
					>
						<template v-slot="{data}">
							<span>
								{{orderDetail.order_type==2?"":"￥"}}
								{{orderDetail.order_type==2?data.product_money:parseFloat(data.sub_product_money).toFixed(2)}}
								{{orderDetail.order_type==2?"积分":""}}
								<font style="text-decoration: line-through;color:#999999;" v-if="data.sub_product_money!=data.original_product_money">
									<br/>
									<!--{{orderDetail.order_type==2?"":"￥"}}-->
									￥
									{{orderDetail.order_type==2?data.original_product_money:parseFloat(data.original_quoted_money).toFixed(2)}}
									<!--{{orderDetail.order_type==2?"积分":""}}-->
								</font>
							</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="已申请退款数"
					>
						<template v-slot="{data}">
							{{data.total_refund_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="已发货数"
						width="80"
					>
						<template v-slot="{data}">
							{{data.send_count}}
						</template>
					</c-table-column>
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="giftProductList.length > 0" v-model="giftProductList" height="auto" :paging="false" border>
					<c-table-column
						label="赠品商品信息"
						width="300"
					>
						<template v-slot="{data}">
							<product-info :image="data.product_img_url" image-size="60" :name="data.product_name"></product-info>
						</template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="150"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="100"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="cusTomList.length > 0" v-model="cusTomList" height="auto" :paging="false" border>
					<c-table-column
						label="定制项"
						width="200"
					>
						<template v-slot="{data}">
							<span v-if="data.item_type==1" style="font-weight:bold;color:chocolate">{{data.custom_name}}</span>
							<span v-if="data.item_type!=1">{{data.custom_name}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制内容"
						width="260"
					>
						<template v-slot="{data}">
							<template v-if="data.item_type==1 && data.custom_value">
								<div class="flex">
									<c-image v-for="(item, i) in data.custom_value.split(',')" :key="i" :src="item" size="50" preview style="margin-right: 10px;"></c-image>
								</div>
							</template>
							<span v-else>{{data.custom_value}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用单价"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用小计"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_money).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用单价(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用小计(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost_money).toFixed(2)}}
						</template>
					</c-table-column>
					
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="reducedList.length > 0" v-model="reducedList" height="auto" :paging="false" border>
					<c-table-column
						label="优惠信息"
						width="400"
					>
						<template v-slot="{data}">
							{{data.remark}} {{data.reduced_money}}元
						</template>
					</c-table-column>
					
					<c-table-column
						label="优惠类型"
					>
						<template v-slot="{data}">
                            {{reducedTypeName[data.reduced_type]}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="优惠金额"
					>
						<template v-slot="{data}">
							{{data.reduced_money}}
						</template>
					</c-table-column>
				</c-table>
				
				<dl v-if="invoiceInfo" class="invoice-info">
					<dt>发票开票信息</dt>
					<dd class="flex">
						<div>
							<div v-if="invoiceInfo.invoice_type == 1" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>普通发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 2" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 3" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票13%</p>
							</div>
							<div class="invoice-info-item flex">
								<label>纳税人识别号：</label>
								<p>{{invoiceInfo.tax_number}}</p>
							</div>
							<div class="invoice-info-item flex">
								<label>收票联系人：</label>
								<p>{{invoiceInfo.contact_name || '--'}}<span v-if="invoiceInfo.contact_phone">（电话：{{invoiceInfo.contact_phone}}）</span><span v-if="invoiceInfo.email">（邮箱：{{invoiceInfo.email}}）</span></p>
							</div>
							<div class="invoice-info-item flex">
								<label>收票地址：</label>
								<p>{{invoiceAddress || '--'}}</p>
							</div>
						</div>
						<div class="flex-grow">
							<div class="invoice-info-item flex">
								<label>发票抬头：</label>
								<p>{{invoiceInfo.invoice_title}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1"  class="invoice-info-item flex">
								<label>开户行账号：</label>
								<p>{{invoiceInfo.bank_account}}（开户行{{invoiceInfo.bank_name}}）</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
								<label>开票地址：</label>
								<p>{{invoiceInfo.kp_address || '--'}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
								<label>开票电话：</label>
								<p>{{invoiceInfo.kp_phone || '--'}}</p>
							</div>
						</div>
                        <div class="flex-grow">
                            <div class="invoice-info-item flex">
                                <label>开票状态：</label>
                                <p>{{orderDetail.invoice_state == 2 ? '已开票':'未开票'}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票完成时间：</label>
                                <p>{{orderDetail.invoice_date}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票实收金额：</label>
                                <p>{{parseFloat(orderDetail.reality_money).toFixed(2)}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票凭证：</label>
                                <p>
                                    <a :href="orderDetail.invoice_file" target="_blank">{{orderDetail.invoice_file}}</a>
                                </p>
                            </div>
                        </div>
					</dd>
				</dl>
				<dl v-if="orderDetail.consignor_name || orderDetail.consignor_phone" class="invoice-info">
					<dt>【代发】发货人信息</dt>
					<dd class="flex">
						<div>
							<div class="invoice-info-item flex">
								<label>发货人姓名：</label>
								<p>{{orderDetail.consignor_name|| '--'}}</p>
							</div>
							<div class="invoice-info-item flex">
								<label>发货人电话：</label>
								<p>{{orderDetail.consignor_phone || '--'}}</p>
							</div>
						</div>
					</dd>
				</dl>
				<div class="order-total flex-between-center" v-if="orderDetail.order_classify != 1">
					<div>商品总额
                        <span v-if="orderDetail.order_type == 3">
                            ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}
                        </span>
                        <span v-else>
                            ￥{{parseFloat(orderDetail.sub_product_money).toFixed(2)}}
                        </span>
                        <span v-if="orderDetail.order_type==7">
                            ，定制费用 ￥{{parseFloat(cusTomInfo.product_price_money).toFixed(2)}}
                        </span>
                        ，运费 ￥{{parseFloat(orderDetail.logistics_money).toFixed(2)}}，其他收费￥{{parseFloat(orderDetail.total_fee_money).toFixed(2)}}
                    </div>
					<div>{{orderDetail.payment_state == 1 ? '应付':'实付'}}总额：
                        <span v-if="orderDetail.payment_state == 3 && orderDetail.order_type == 3"><b>￥{{parseFloat(orderDetail.payment_money).toFixed(2)}}</b></span>
                        <span v-else><b>￥{{parseFloat((orderDetail.order_number == orderDetail.sub_order_number?(parseFloat(orderDetail.product_money)+parseFloat(orderDetail.logistics_money)):(parseFloat(orderDetail.sub_product_money)+parseFloat(orderDetail.logistics_money)))).toFixed(2)}}</b></span>
                    </div>
				</div>
			</div>
			
			<template slot="button">
				<c-button power="b_order_edit_price" v-if="orderDetail.operation_mode == 1 && orderDetail.order_state == 1 && orderDetail.payment_state == 1 && orderDetail.order_type != 2" size="m" hollow @click="orderEditPriceHandle()">调价</c-button>
				<c-button power="b_order_check" v-if="orderDetail.operation_mode == 1 && orderDetail.order_state <= 2 && orderDetail.check_state == 1" size="m" @click="checkHandle('pass')">审核通过</c-button>
				<c-button power="b_order_check" v-if="orderDetail.operation_mode == 1 && orderDetail.order_state <= 2 && orderDetail.check_state == 1" size="m" color="red" @click="checkHandle('reject')">审核不通过</c-button>
				<c-button color="sys" power="b_order_deliver" v-if="((orderDetail.order_classify ==1 && (orderDetail.agency_user_id == -2 || is_df == 1)) || orderDetail.order_classify == 2 || orderDetail.order_classify == 3 || orderDetail.order_classify == 4 )&& orderDetail.operation_mode == 1 && orderDetail.refunding_count==0 && orderDetail.returning_count==0 && orderDetail.check_state == 2 && (orderDetail.order_state == 2 || (orderDetail.order_state == 3 && orderDetail.deliver_state =='部分发货'))" size="m" @click="orderSendHandle()">发货</c-button>
				<!-- <c-button power="b_order_deliver" v-if="orderDetail.operation_mode == 1 && orderDetail.refunding_count==0 && orderDetail.returning_count==0 && orderDetail.check_state == 2 && (orderDetail.order_state == 2 || (orderDetail.order_state == 3 && orderDetail.deliver_state =='部分发货'))" size="m" @click="orderSendAllHandle()">发货（全部）</c-button> -->
				<c-button power="b_customer_service_remark" size="m" hollow @click="orderRemarkHandle()">客服备注</c-button>
				<c-button power="b_customer_service_remark_record" size="m" hollow @click="showRemarkList">查看客服备注</c-button>
				<c-button power="b_order_edit_receiving_address" v-if="orderDetail.operation_mode == 1 && (orderDetail.order_state == 1 || orderDetail.order_state == 2) && orderDetail.push_state != 2" size="m" hollow @click="editReceivingAddress(orderDetail)">修改收货信息</c-button>
				<c-button power="b_order_close"  v-if="orderDetail.order_type==1 && orderDetail.operation_mode == 1 && orderDetail.refunding_count==0 && orderDetail.returning_count==0 && orderDetail.order_state <= 2 && orderDetail.order_type != 7" size="m" hollow @click="closeHandle()">关闭订单</c-button>
				<c-button power="b_order_close"  v-if="orderDetail.operation_mode == 1 && orderDetail.refunding_count==0 && orderDetail.returning_count==0 && orderDetail.order_state <= 2 && orderDetail.order_type == 7 && orderDetail.payment_state != 3" size="m" hollow @click="closeHandle()">关闭订单</c-button>
				<c-button power="b_order_update_remark" v-if="orderDetail.order_state <= 2" @click="reMarkHandle()" size="m" hollow>修改买家留言</c-button >
				<c-button power="b_order_invoice_finish" v-if="systemConfig.order_invoice_enabled == 'ON' && orderDetail.check_state == 2 && orderDetail.invoice_state == 1 && (orderDetail.order_state == 3 || orderDetail.order_state == 5) && invoiceInfo !=null " size="m" hollow @click="onInvoiceFinish()">开票完成</c-button>
				<c-button power="b_order_download" v-if="orderDetail.operation_mode == 1 && orderDetail.check_state == 2 && orderDetail.order_state != 1 && orderDetail.order_state != 6" @click="downOrder(0)" size="m" hollow>下载订单</c-button >
				<c-button power="b_order_detail" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5" size="m" hollow @click="showLogistics">查看物流</c-button>
			</template>
		</module>
		
		<!--订单调价 -->
		<c-dialog ref="orderEditPrice" title="订单调价" width="900" button-name="确定调价" @resolve="orderEditPriceHandle">
			<c-table ref="orderEditList" v-model="editList" height="320" :paging="false">
				<c-table-column
					label="商品信息"
					width="300"
				>
					<template v-slot="{data}">
						<product-info :image="data.product_img_url" image-size="60" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="规格信息"
					name="product_sku_spec"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="商品SKU编码"
					width="120"
				>
					<template v-slot="{data}">
						{{data.product_sku_code?data.product_sku_code:'--'}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="原单价"
					width="80"
				>
					<template v-slot="{data}">
						￥{{parseFloat(data.original_unit_money).toFixed(2)}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商品数量"
					width="80"
				>
					<template v-slot="{data}">
						×{{data.product_count}}
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="原价小计"
					width="100"
				>
					<template v-slot="{data}">
						￥{{data.product_money}}
					</template>
				</c-table-column> -->
				
				<c-table-column
					label="现单价"
					width="90"
				>
					<template v-slot="{data}">
						￥<c-input v-model="data.product_unit_price" type="number" :limit="999999" decimal="2" width="60" ></c-input> 
					</template>
				</c-table-column>
				
				<c-table-column
					label="成交小计"
					width="100"
				>
					<template v-slot="{data}">
						￥{{(data.product_count * (parseFloat(data.product_unit_price) || 0)).toFixed(2)}}
					</template>
				</c-table-column>
			</c-table>
			<div class="order-price_total flex-between-center"  style="padding:10px; background-color: #efefef;">
				<div>调价后商品总额：￥<span><b>{{parseFloat(newProductMoney).toFixed(2)}}</b></span><span v-if="orderDetail.order_type==7">，定制费用 ￥{{parseFloat(cusTomInfo.product_price_money).toFixed(2)}}</span>，运费 ￥<c-input v-model="new_logistics_money" type="number" :limit="999999" decimal="2" width="60" ></c-input> <!-- ，其他收费￥{{parseFloat(orderDetail.total_fee_money).toFixed(2)}} --></div>
				<div>调价后应付总额：<span><b>￥{{(newProductMoney+(cusTomInfo.product_price_money||0)+parseFloat(new_logistics_money||0)).toFixed(2)}}</b></span></div>
			</div>
		</c-dialog>
		
		<!--订单发货弹框（部分发货） -->
		<c-dialog ref="orderSend" title="订单发货" width="900" button-name="发货" @resolve="orderSendHandle">
			<div style="background: #FAFAFA;">
        <m-operate>
          <c-checkbox :checked="this.self_pick" @change="changeSelfPick($event)"></c-checkbox> &nbsp;&nbsp;无需物流&nbsp;&nbsp;
          <c-button @click="addCompany()" :disabled="self_pick">添加包裹</c-button>
        </m-operate>
        <c-table ref="orderSendCompany" v-model="sendCompanyList" height="200" :paging="false">
          <c-table-column
              label="物流公司"
              width="200"
          >
            <template v-slot="{data}">
              <c-select :options="logisticsCompany" v-model="data.logistics_company_name" :disabled="self_pick"></c-select>
            </template>
          </c-table-column>

          <c-table-column
              label="运单号"
              width="150"
          >
            <template v-slot="{data}">
              <c-input v-model="data.logistics_number" :disabled="self_pick"></c-input>
            </template>
          </c-table-column>

          <c-table-column label="操作" width="80">
            <template v-slot="row">
              <c-button color="sys"  v-if="sendCompanyList.length > 1" @click="row.remove()" >删除</c-button>
            </template>
          </c-table-column>
        </c-table>
			</div>
			<c-table ref="orderSendList" v-model="sendList" height="320" :paging="false">
				<c-table-column
					type="selector"
					:selected="() => true"
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					width="300"
				>
					<template v-slot="{data}">
						<product-info :image="data.product_img_url" image-size="60" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="规格信息"
					name="product_sku_spec"
				></c-table-column>
				
				<c-table-column
					label="未发数量"
				>
					<template v-slot="{data}">
						×{{data.product_quantity}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货数量"
					width="150"
				>
					<template v-slot="{data, selected}">
						<c-input v-model="sendNum[data.product_sku]" type="number" width="100" :limit="[1, data.product_quantity]" :disabled="!selected"></c-input> 件
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<!--订单发货弹框（全部发货） -->
		<c-dialog ref="orderSendAll" title="订单发货（全部发货） " width="500" button-name="发货" @resolve="orderSendAllHandle">
			<div style="background: #FAFAFA;">
				<c-form ref="orderSendAllForm">
					<c-form-item type="select" name="logistics_company_name" label="物流公司" :options="logisticsCompany" v-model="logistics_company_name"></c-form-item>
					<c-form-item type="input" name="logistics_number" label="运单号" ></c-form-item>
				</c-form>
			</div>
		</c-dialog>
		
		<!--物流信息查询弹框 -->
		<c-dialog ref="logistics" title="物流信息" width="900" :button="false">
			<div class="logistics">
				<div v-show="express_list" style="overflow: auto;">
					<ul class="logistics-order flex" style="float: left;">
					  <li v-for="(item, i) in express_list" :key="i" :class="{'z-crt': item == crtExpress}" @click="crtExpress = item">
						  <p>{{item.logistics_company}}【{{item.logistics_number}}】</p>
					  </li>
					</ul>
				</div>
				<ul v-if="crtExpress" class="logistics-list">
					<li v-for="(item, i) in crtExpress.track" :key="i" class="flex">
						<p>{{item.time}}</p>
						<p class="flex-grow" style="margin-left: 20px;">{{item.status}}</p>
					</li>
				</ul>
				<ul v-else class="logistics-list">
					暂无轨迹数据
				</ul>
			</div>
		</c-dialog>
		
		<!--客服备注弹框（输入） -->
		<c-dialog ref="orderRemark" title="客服备注" width="700" @resolve="orderRemarkHandle">
			<div class="order-remark">
				<textarea v-model="orderRemark" placeholder="请输入备注内容..."></textarea>
			</div>
		</c-dialog>
		
		<!--客服备注弹框（列表） -->
		<c-dialog ref="remarkList" title="客服备注" width="700" :button="false">
			<c-table v-model="remarkList" height="400" :paging="false" border>
				<c-table-column
					label="备注人"
					name="create_user_realname"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="备注内容"
					name="customer_service_remark"
					width="280"
				></c-table-column>
				
				<c-table-column
					label="备注时间"
					name="create_date"
				></c-table-column>
			</c-table>
		</c-dialog>
		
		<!--审核不通过原因弹框 -->
		<c-dialog ref="rejectReason" title="不通过原因" width="550" button-name="审核不通过" @resolve="rejectHandle">
			<div class="order-remark">
				<textarea v-model="rejectReason" placeholder="请输入不通过原因..."></textarea>
			</div>
		</c-dialog>
		
		<!--关闭订单弹框-->
		<c-dialog ref="closeDia" title="关闭订单" width="600" @resolve="closeHandle">
			<div class="order-remark">
			  	<textarea v-model="cancel_reason" placeholder="请输入取消原因..."></textarea>
			</div>
		</c-dialog>
		
		<!--修改买家留言弹框-->
		<c-dialog ref="reMarkDia" title="修改买家留言" width="600" @resolve="reMarkHandle">
			<div class="order-remark">
			  	<textarea v-model="order_remark" placeholder="请买家留言..."></textarea>
			</div>
		</c-dialog>

        <c-dialog ref="receivingDia" title="修改收货地址" width="700" @resolve="receivingSubmitForm">
            <c-form ref="receivingForm">
                <c-form-item type="hidden" name="order_number"></c-form-item>
                <c-form-item type="input" label="收货人" name="receiving_name" required></c-form-item>
                <c-form-item type="input" label="电话" name="receiving_phone" required></c-form-item>
                <c-form-item type="region" label="收货地址"
                             province-name="receiving_address_province_id"
                             city-name="receiving_address_city_id"
                             county-name="receiving_address_county_id"
                             required></c-form-item>
                <c-form-item type="input" label="地址详情" name="receiving_address_details" required></c-form-item>
                <c-form-item type="textarea" v-model="analysis_text"  placeholder="请填入收件人姓名、电话、地址信息，系统将自动识别"></c-form-item>
                <m-operate style="position: absolute;right: 0;">
                    <c-button color="red" @click="analysisAddress()" style="margin-right:20px">智能识别</c-button>
                </m-operate>
            </c-form>
        </c-dialog>
		
		<!--开票完成弹框-->
		<c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="500" height="360" @resolve="submitInvoiceFinish">
			<c-form>
			<div class="invoice">
        <p v-html="text_msg"></p>
					<!-- <c-datetime label="开票时间" v-model="invoiceDate" type="date"></c-datetime> -->
				<c-form-item type="datetime" v-model="invoiceDate" label="开票时间" ></c-form-item>
				<c-form-item type="number" v-model="realityMoney" :limit="9999999" decimal="2" label="实收金额" ></c-form-item>
        <c-form-item type="radio"  label="开票凭证" name="invoice_file_type" v-model="invoice_file_type" :options="invoiceFileType"></c-form-item>
        <c-form-item type="file" v-if="invoice_file_type == 1" label="附件" v-model="invoice_file" name="invoice_file" file-type="image,pdf"></c-form-item>
        <c-form-item type="input" v-if="invoice_file_type == 2" label="链接" v-model="invoice_file" word="http://或https://开头" name="invoice_file" ></c-form-item>
			</div>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import {mapState} from 'vuex'
	export default {
		name: 'order_detail',
		
		components: {
			productInfo
		},
		
		props: {
			orderNumber: String,
			is_df: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo:'',
				invoiceInfo:'',
				invoiceDate:'',
				realityMoney: 0,
				sendList: [],
				editList: [],
				logistics_company_name:'',
				self_pick:false,//true=自提
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info:[],
				new_logistics_money: 0,
				old_money: 0,
		        invoice_file_type:'',//开票文件类型
		        invoice_file:'',//发票文件
		        invoiceFileType:[{
		            name: '附件',
		            value: 1
		        },{
		            name: '链接',
		            value: 2
		        }],
		        text_msg:'',
		        reducedTypeName: {
		            0: '会员卡礼包',
		            1: '优惠券',
		            2: '限时折扣活动优惠',
		            3: '会员等级折扣',
		            4: '砍价活动优惠',
		            5: '抽奖奖品优惠',
		            6: '积分抵扣'
		        },
		        sendCompanyList:[],
				companyIdIndex:1,
				express_list:[],//物流轨迹
				crtExpress: null,
                analysis_text:''
		      }//end return
		},
		
		computed: {
			...mapState(['systemConfig']),
			
			checkState() {
				return {
					1: this.orderDetail.order_state == 6 ? '':'（待审核）',
					2: this.orderDetail.order_state == 6 || this.orderDetail.order_state == 1 ? '':'（审核通过'+(this.orderDetail.push_state == 1 ? '':'')+'）',
					3: '（审核驳回）',
				}[this.orderDetail.check_state];
			},
			orderState() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0){
				  msg = "订单申请【仅退款】";
				}else if (this.orderDetail.returning_count > 0){
				  msg = "订单申请【退货】";
				}else {
				  msg = {
					1: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason +')':'等待买家付款',
					2: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason +')':'买家已付款，等待商家发货',
					3: '已' + this.orderDetail.deliver_state + (this.orderDetail.deliver_state=='全部发货' ? '，待买家确认收货':'，还有部分货品未发'),
					5: '交易已完成',
					6: this.orderDetail.check_state == 3 ? '审核不通过':'订单已取消'
				  }[this.orderDetail.order_state];
				}
				return msg;
			},
			orderStateWord() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0){
					msg = "订单存在【仅退款】申请，请先处理完成后再进行其他操作";
				}else if (this.orderDetail.returning_count > 0){
					msg = "订单存在【退货】申请，请先处理完成后再进行其他操作";
				}else {
					if(this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2){
						msg = "等待买家支付尾款";
					}else{
					
						msg = {
							  1:  this.orderDetail.payment_type == '银行转账' ? '当前订单使用银行转账方式支付，请及时审核':'请在 ' + this.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
							  // 1:  '请尽快通知客户完成付款（1、客户自行付款，2、销售内勤使用授信挂账审批通过，3、销售内勤执行审批不通过）',
							  2: '买家已付款，请尽快发货',
							  3: (this.orderDetail.deliver_state=='全部发货' ? '如客户未确认收货，订单将于' + this.orderDetail.last_confirm_date + '自动确认收货':''),
							  5: '完结时间：' + this.orderDetail.confirm_date,
							  6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name:'') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）':'')
						  }[this.orderDetail.order_state];
					}
				}
				return msg;
			},
			
			paymentState() {
				return {
					1: '待付款',
					2: '待付尾款',
					3: '已付款'
				}[this.orderDetail.payment_state];
			},
			
			paymentTotal() {
				if(this.orderDetail.order_type == 7 ){
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money||0).toFixed(2):(this.orderDetail.product_money  + this.cusTomInfo.product_price_money+ this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				}else{
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money||0).toFixed(2):(this.orderDetail.product_money  + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				}
			},
			
			newProductMoney() {
				var total_product_money = 0;
				this.editList.forEach(item => {
					total_product_money += (parseFloat(item.product_unit_price) || 0 ) * item.product_count;
					
				});
				 return total_product_money;
			},
			
			invoiceAddress() {
				if (!this.invoiceInfo) return '';
				return (this.invoiceInfo.address_province_name || '') + (this.invoiceInfo.address_city_name || '') + (this.invoiceInfo.address_county_name || '') + (this.invoiceInfo.address_details || '');
			}
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
			//获取订单详情数据
			getOrderDetail() {
				this.request({
					url: '/order/detail',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.reducedList = data.reduced_list;
						this.cusTomList = data.custom_list||[];
						this.cusTomInfo = data.custom_info||{};
						this.invoiceInfo = data.invoice_info;
						this.pack_info = data.pack_info;
						this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money||0).toFixed(2):(this.orderDetail.product_money  + (this.cusTomInfo.product_price_money||0) + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
					}
				});
			},
			//订单调价弹框输入等信息录入
			orderEditPriceHandle(stop) {
				if (!stop) {
					this.request({
						url: '/order/undelivered/product/list',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.editList = data;
							this.new_logistics_money = this.orderDetail.logistics_money||'0.00';
							this.$refs.orderEditPrice.open();
						}
					});
					
				} else {
					stop();
					
					var flag = false;
					var new_total_money = 0;
					this.editList.forEach(item => {
						if(!item.product_unit_price){
							this.$message({
								text: '请输入调价后单价'
							});
							flag = true;
							return;
						}else if(parseFloat(item.product_unit_price) <= 0){
							this.$message({
								text: '调价后的单价不能小于等于0'
							});
							flag = true;
							return;
						}else{
							new_total_money += (parseFloat(item.product_unit_price) || 0 ) * item.product_count;
						}
					});
					
					if(!this.new_logistics_money){
						this.$message({
							text: '请输入运费'
						});
						flag = true;
						return;
					}else if(parseFloat(this.new_logistics_money) < 0){
						this.$message({
							text: '运费不能小于0'
						});
						flag = true;
						return;
					}
					
					if(flag){
						return;
					}
					new_total_money = new_total_money + (this.cusTomInfo.product_price_money||0) + parseFloat(this.new_logistics_money||0);
					
					if(new_total_money <= 0){
						this.$message({
							text: '调价后的应付总额不能为0元'
						});
					}
					
					this.$confirm({
						text: `确定要对当前订单执行调价操作吗？<br>(原应付金额:￥${this.old_money}，调价后应付金额:<span style="color: #f00">￥${parseFloat(new_total_money).toFixed(2)}</span>)`,
						resolve: () => {
							this.orderEditPriceVerifyHandle();
							this.$refs.orderEditPrice.close();
							this.$bus.$emit('order.update', {});
						}
					});
				}
			},
			//执行订单调价请求
			orderEditPriceVerifyHandle() {
				this.request({
					url: '/order/editPrice',
					data: Object.assign( {
						order_number: this.orderNumber,
						logistics_money: this.new_logistics_money,
						product_skus: Array.from(this.editList, item => {
							return {
								product_sku: item.product_sku,
								product_unit_price: parseFloat(item.product_unit_price) || 0
							}
						})
					}),
					loading: true,
					success: () => {
						this.$refs.orderEditPrice.close();
						this.$message({
							text: '调价执行成功'
						});
						this.getOrderDetail();
					}
				});
			},
			//订单发货（部分发货）
			orderSendHandle(stop) {
				if (!stop) {
				          this.companyIdIndex = 1;
				          this.sendCompanyList = [{
				              id:this.companyIdIndex,
				              logistics_company_name:'',
				              logistics_number:''
				          }];
						if (!this.logisticsCompany.length) {
							this.request({
								url: '/standard_logistics/list',
								success: data => {
									this.logisticsCompany = Array.from(data, item => {
										return {
											name: item.option,
											value: item.option
										};
									});
								}
							});
						}
						this.request({
						url: '/order/undelivered/product/list',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.sendList = data;
							this.logistics_company_name = this.orderDetail.last_logistics_company;
							this.$refs.orderSend.open();
							//赋值默认发货数量
							this.sendList.forEach(item => {
								this.sendNum[item.product_sku] = item.product_quantity;
							});
							
						}
					});
				} else {
					stop();
					
					let list = this.$refs.orderSendList.getRow('selected');
					
					new Promise(resolve => {
            if (!this.self_pick && (!this.sendCompanyList || this.sendCompanyList.length==0)){
              resolve('请填写物流公司信息');
            }
            if (!this.self_pick && this.sendCompanyList.find(item => {
              return (!item.logistics_company_name || item.logistics_company_name=='');
            })) {
              resolve('请填写物流公司信息');
            }
            if (!this.self_pick && this.sendCompanyList.find(item => {
              return (!this.self_pick && item.logistics_company_name!='自提'&&(!item.logistics_number || item.logistics_number==''));
            })) {
              resolve('请填写运单号信息');
            }
            //查询运单号是否重复
            let logistics_numbers = this.sendCompanyList.filter((item, index, self) => {
              // 返回第一个匹配项的索引，用于判断当前项是否为第一个匹配项
              const firstIndex = self.findIndex((obj) => obj.logistics_number === item.logistics_number);
              // 如果当前项是第一个匹配项，则保留，否则过滤掉
              return index === firstIndex;
            });
            if (logistics_numbers.length != this.sendCompanyList.length){
              resolve('存在重复的运单号，请检查');
            }
						
						if (!list.length) {
							resolve('请选择要发货的商品');
						}
						
						if (list.find(item => {
							return (parseInt(this.sendNum[item.data.product_sku]) || 0) <= 0;
						})) {
							resolve('请填写已选商品的发货数量');
						}
						
						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								text: error
							});
							return;
						}
						
						this.request({
							url: '/order/deliver',
							data: {
								order_number: this.orderNumber,
								send_products: Array.from(list, item => {
									return {
										product_sku: item.data.product_sku,
										send_quantity: parseInt(this.sendNum[item.data.product_sku])
									}
								}),
                self_pick:this.self_pick?1:0,
                logistics_company_list: this.self_pick?[]:Array.from(this.sendCompanyList, item => {
                  return {
                    logistics_company_name: item.logistics_company_name,
                    logistics_number: item.logistics_number
                  }
                })
							},
							loading: true,
							success: data => {
								this.$refs.orderSend.close();
								this.$message({
									text: '发货成功'
								});
								this.getOrderDetail();
							}
						});
					});
				}
			},
			//订单发货（全部发货）
			orderSendAllHandle(stop) {
				if (!stop) {
					if (!this.logisticsCompany.length) {
						this.request({
							url: '/standard_logistics/list',
							success: data => {
								this.logisticsCompany = Array.from(data, item => {
									return {
										name: item.option,
										value: item.option
									};
								});
								this.$refs.orderSendAllForm.set({
									logistics_company_name: this.orderDetail.last_logistics_company
								});
							}
						});
					} else {
						this.$refs.orderSendAllForm.set({
							logistics_company_name: this.orderDetail.last_logistics_company
						});
					}
					this.$refs.orderSendAll.open();
				} else {
					stop();
					
					let form = this.$refs.orderSendAllForm.serialize();
					
					new Promise(resolve => {
						if (!form.logistics_company_name) {
							resolve('请选择物流公司');
						}

						if (form.logistics_company_name!='自提' && !form.logistics_number) {
							resolve('请填写运单号');
						}

						resolve(false);
					}).then(error => {
						if (error) {
							this.$message({
								text: error
							});
							return;
						}
						
						this.request({
							url: '/order/deliverall',
							data: Object.assign(form, {
								order_number: this.orderNumber
							}),
							loading: true,
							success: data => {
								this.$refs.orderSendAll.close();
								this.$message({
									text: '发货成功'
								});
								this.getOrderDetail();
							}
						});
					});
				}
			},
			//物流轨迹
			showLogistics() {
				this.request({
					url: '/order/express',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.express_list = data||[];
						this.crtExpress = data[0];
						//展示物流轨迹信息
						this.$refs.logistics.open();
					}
				});
			},
			//客服备注
			orderRemarkHandle(stop) {
				if (!stop) {
					this.orderRemark = '';
					this.$refs.orderRemark.open();
				} else {
					stop();
						
					if (!this.orderRemark.trim()) {
						this.$message({
							text: '请填写备注'
						});
						return;
					}
					
					this.request({
						url: '/order/add_customer_service_remark',
						data: {
							order_number_arr: [this.orderNumber],
							customer_service_remark: this.orderRemark.trim()
						},
						loading: true,
						success: () => {
							this.$refs.orderRemark.close();
							this.$message({
								text: '备注成功'
							});
						}
					});
				}
			},
			//显示客服备注
			showRemarkList() {
				this.request({
					url: '/order/query_customer_service_remark_list',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.remarkList = data;
						this.$refs.remarkList.open();
					}
				});
			},
			//审核订单
			checkHandle(type, confirm) {
				if (type == 'pass') {
					this.$confirm({
						text: '确定要审核通过该订单吗？',
						resolve: () => {
							this.request({
								url: '/order/check',
								data: {
									order_number: this.orderNumber, check_state: 2, push_u8: 2
								},
								loading: true,
								success: () => {
									this.$message({
										text: '订单审核成功'
									});
									this.getOrderDetail();
									this.$bus.$emit('order.update', {});
								}
							});
						}
					});
				} else if (confirm) {
					this.request({
						url: '/order/check',
						data: {
							order_number: this.orderNumber,
							check_state: 3,
							push_u8: 0, 
							reject_reason: this.rejectReason.trim()
						},
						loading: true,
						success: () => {
							this.$message({
								text: '订单审核不通过执行成功'
							});
							this.getOrderDetail();
							this.$bus.$emit('order.update', {});
						}
					});
				} else {
					this.rejectHandle();
				}
			},
			//审核（提交数据）
			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();
						
					if (!this.rejectReason.trim()) {
						this.$message({
							text: '请填写审核不通过原因'
						});
						return;
					}
					
					this.checkHandle('reject', true);
					this.$refs.rejectReason.close();
					this.$bus.$emit('order.update', {});
				}
			},
			//关闭订单（弹窗）
			closeHandle(stop){
				if (!stop) {
					this.cancel_reason = '';
					this.$refs.closeDia.open();
				} else {
					stop();
					if (!this.cancel_reason.trim()) {
						this.$message({
							text: '请填写关闭订单原因'
						});
						return;
					}
					this.closeSubmitForm();
					this.$refs.closeDia.close();
					this.$bus.$emit('order.update', {});
				
				}
			},
			//关闭订单（提交数据）
			closeSubmitForm() {
				this.request({
					url: '/order/cancel',
					data: {
						order_number: this.orderNumber,
						cancel_reason: this.cancel_reason.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							text: '申请取消订单成功'
						});
						this.getOrderDetail();
						this.$bus.$emit('order.update', {});
					}
				});
			},
			//修改订单备注
			reMarkHandle(stop) {
				if (!stop) {
					this.order_remark = this.orderDetail.order_remark;
					this.$refs.reMarkDia.open();
				} else {
					stop();
					this.request({
						url: '/order/update_remark',
						data: {
							order_number: this.orderNumber,
							order_remark: this.order_remark.trim()
						},
						loading: true,
						success: () => {
							this.$refs.reMarkDia.close();
							this.$message({
								text: '修改买家留言成功'
							});
							this.getOrderDetail();
						}
					});
				}
			},
			//下载订单
			downOrder(type){
				this.request({
				    url: '/order/getdownloadurl',
				    data: {
				        order_number: this.orderDetail.order_number,
						type: type
				    },
				    loading: true,
				    success: data => {
				        window.open(data);
				    }
				});
			},
			onInvoiceFinish() {

				this.order_ids = [this.orderDetail.id];
				this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.realityMoney = parseFloat(this.orderDetail.payment_money||0).toFixed(2);
				this.$refs.invoiceConf.open();
                this.text_msg = `确定要对订单【<font style="font-size:15px;color:red;">${this.orderDetail.order_number}</font>】执行开票完成操作吗？`;
			},
			submitInvoiceFinish(stop){
				stop();
				if (!this.invoiceDate) {
					this.$message({
						text: '请选择开票时间'
					});
					return;
				}
				if (!this.realityMoney) {
					this.$message({
						text: '请输入实收金额'
					});
					return;
				}
                if (!this.invoice_file_type) {
                    this.$message({
                        text: '请选择开票凭证'
                    });
                    return;
                }
                if (!this.invoice_file) {
                    if(this.invoice_file_type == 1){
                        this.$message({
                            text: '请上传附件'
                        });
                        return;
                    }
                    if(this.invoice_file_type == 2){
                        this.$message({
                            text: '请输入链接'
                        });
                        return;
                    }
                } else if (this.invoice_file_type == 2) {
                    if(this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0){
                        this.$message({
                            text: '请输入以http://或https://开头的完整链接'
                        });
                        return;
                    }
                }
				this.request({
					url: '/order/invoice_finish',
					data: {
						order_ids: this.order_ids,
						invoice_date: this.invoiceDate,
						reality_money: this.realityMoney,
						is_bath: 0,
                        invoice_file_type: this.invoice_file_type,
                        invoice_file: this.invoice_file
					},
					loading: true,
					success: data => {
						this.$message({
							icon: 'success',  
							text: '执行开票完成操作成功'
						});
						this.getOrderDetail();
						this.$refs.invoiceConf.close();
					}
				});
			},
      //修改收货地址（弹框）
      editReceivingAddress(val){
          this.$refs.receivingForm.clear();
          this.$refs.receivingForm.set(val);
          this.$refs.receivingDia.open();
      },
      //地址智能识别
      analysisAddress() {
            if (!this.analysis_text || this.analysis_text.length == 0){
                this.$message({
                    text: '请输入需要识别的内容',
                    icon: 'fail'
                });
                return false;
            }
            this.request({
                url: '/platform_user/address/analysis',
                data: {
                    text: this.analysis_text
                },
                loading: true,
                timeout: false,
                success: (data, message) => {
                    this.$refs.receivingForm.set(data);
                    this.$message({
                        text: '智能识别成功',
                        icon: 'success'
                    });
                }
            });
      },
      //修改收货地址（提交数据）
      receivingSubmitForm(stop){
                stop();
                this.$refs.receivingForm.submit({
                    url: '/order/edit_receiving_address',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address_province_id: '请选择收货地址省份',
                        receiving_address_city_id: '请选择收货地址城市',
                        receiving_address_county_id: '请选择收货地址区县',
                        receiving_address_details: '请填写收货地址详情'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改收货信息成功！'
                        });
                        //刷新页面
                        this.getOrderDetail();
                        this.$refs.receivingDia.close();
                    }
                });
            },

      changeSelfPick(state) {
        this.self_pick = state;
        console.log('this.self_pick=============='+this.self_pick);
      },

      addCompany(){
        this.companyIdIndex = this.companyIdIndex + 1;
        var compamyObj = {};
        compamyObj.id = this.companyIdIndex;
        compamyObj.logistics_company_name = '';
        compamyObj.logistics_number = '';
        this.sendCompanyList.push(compamyObj);
      }
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme'
	
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
			
			h1 {
				font-size: 24px;
			}
		}
		
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				p {
					a {
						color: #005CD9;
					}
				}
			}
            .tag {
                align-self: center;
                border-radius: 2px;
                padding: 0 5px;
                margin-left: 6px;
                line-height: 18px;
                color: #fff;
            }
		}
		
		&-detail {
			padding: 30px 30px 40px;
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				theme-color(main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 10px 12px;
				line-height: 22px;
				font-size: 14px;
				white-space: nowrap;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 12px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>